module.exports = function(value) {
    return value === 'true' || value === true
}
